import axios from 'axios';
import { useQuery } from '@tanstack/react-query';
import { IHousingObjectResponse } from '@/types';
import { GET_HOUSING_OBJECT_API_ENDPOINT } from '@/constants';

export const useGetHousingObject = (objectId?: string) =>
  useQuery({
    queryKey: ['housing-object', String(objectId)],
    queryFn: () =>
      axios
        .get<IHousingObjectResponse>(`${GET_HOUSING_OBJECT_API_ENDPOINT}/${objectId}`)
        .then((res) => res.data),
    refetchOnWindowFocus: false,
    staleTime: 0,
    enabled: Boolean(objectId),
  });
